export default {
  FIND_ALL (state, payload) {
    state.rows = payload
  },
  ADD (state, payload) {
    state.row = payload
  },
  EDIT (state, payload) {
    state.row = payload
  },
  SAVE (state, payload) {
    state.row = null
  },
  REMOVE (state, payload) {
    state.rows = state.rows.filter(row => row.id !== payload.id)
  },
  TWITTER_LOGIN_PAGE (state, payload) {
    state.twitterLoginPage = payload
  },
  TWITTER_LOGIN (state, payload) {
    state.twitterLogin = payload
  },
  SAVE_TWITTER_LOGIN (state, payload) {
    state.twitterLoginDetail = payload
  },
  PUBLISH_PAGE (state, payload) {
    state.publishPage = payload
  }
}
